/* eslint-disable */
export default class Cookie {
  static set(name, value, expiredays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = name + '=' + escape(value);
    +';path=/;domain=aliyun.com;' + (expiredays == null ? '' : ';expires=' + exdate.toGMTString());
  }
  static get(key) {
    var cookies = document.cookie ? document.cookie.split('; ') : [],
      i = 0,
      l = cookies.length,
      result;

    for (; i < l; i++) {
      var parts = cookies[i].split('='),
        name = decodeURIComponent(parts.shift()),
        cookie = parts.join('=');

      if (key === name) {
        var parseCookieValue = function(s) {
          var pluses = /\+/g;

          if (s.indexOf('"') === 0) {
            s = s
              .slice(1, -1)
              .replace(/\\"/g, '"')
              .replace(/\\\\/g, '\\');
          }
          try {
            return decodeURIComponent(s.replace(pluses, ' '));
          } catch (e) {}
        };

        result = parseCookieValue(cookie);
        break;
      }
    }
    return result;
  }
  static delete(name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = getCookie(name);
    if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
  }
}



// WEBPACK FOOTER //
// ./src/components/cookie.js